let baseUrl
let publicKey
let testToken = null

export default {
  baseUrl,
  publicKey,
  testToken,
}